import React from 'react';

import { useMixPanelTrakingEventMutation } from '@/api/commonApis';

import { COSTING_MIX_PANEL_EVENTS } from '../utils';

const ActionButtons = ({
	onSubmit,
	onReCost,
	hasChanges,
	isEditable = true,
	hasSubmittedCosting = false
}) => {
	const [mixPanelTrakingEvent] = useMixPanelTrakingEventMutation();

	return (
		<div className="costing-summary-bottom border mb-3 p-3">
			{isEditable ? (
				hasChanges ? (
					<button
						className="button size32 w-100"
						onClick={() => {
							mixPanelTrakingEvent({
								type: COSTING_MIX_PANEL_EVENTS.RECOST_BUTTON_CLICK,
								body: {}
							});
							onReCost?.();
						}}
					>
						<span className="regular-14 weight-500">Re-Cost</span>
					</button>
				) : (
					<button className="button size32 w-100" onClick={onSubmit} disabled={hasSubmittedCosting}>
						<span className="regular-14 weight-500">Submit</span>
					</button>
				)
			) : null}
		</div>
	);
};

export default ActionButtons;
